<template>
  <div>
    <el-row class="small-title">
      {{$t("title.system.point.table.userPointTotal")}}
    </el-row>

    <el-table
      :data="result"
      class="table-type">

      <!--  ユーザー名 -->
      <el-table-column
        prop="holderName"
        :label="$t('title.system.point.table.userName')"
        class-name="col-2"/>

      <!--  当前月 -->
      <el-table-column
        class-name="col-1"
        :label="this.getMonth(0)" >
          <span slot-scope="scope" :class="{color: scope.row.pointList[0].invalidAmount > 0}">
            {{scope.row.pointList[0].balance}}
          </span>
        </el-table-column>


      <el-table-column
        class-name="col-1"
        :label="this.getMonth(1)">

        <span slot-scope="scope" :class="{color: scope.row.pointList[1].invalidAmount > 0}">
            {{scope.row.pointList[1].balance}}
          </span>
        </el-table-column>

      <el-table-column
        class-name="col-1"
        :label="this.getMonth(2)" >
          <span slot-scope="scope" :class="{color: scope.row.pointList[2].invalidAmount > 0}">
            {{scope.row.pointList[2].balance}}
          </span>
        </el-table-column>

      <el-table-column
        class-name="col-1"
        :label="this.getMonth(3)">
        <span slot-scope="scope" :class="{color: scope.row.pointList[3].invalidAmount > 0}">
          {{scope.row.pointList[3].balance}}
        </span>
      </el-table-column>

        <el-table-column
        class-name="col-1"
        :label="this.getMonth(4)">
          <span slot-scope="scope" :class="{color: scope.row.pointList[4].invalidAmount > 0}">
            {{scope.row.pointList[4].balance}}
          </span>
        </el-table-column>

      <el-table-column
        class-name="col-1"
        :label="this.getMonth(5)">
        <span slot-scope="scope" :class="{color: scope.row.pointList[5].invalidAmount > 0}">
          {{scope.row.pointList[5].balance}}
        </span>
      </el-table-column>


      <el-table-column
        class-name="col-2"
        :label="$t('title.system.point.table.invalidPointTotal')">
          <span slot-scope="scope" :class="{color: sumRealPoint(scope.row) > 0}">
            {{sumRealPoint(scope.row)}}
          </span>
      </el-table-column>

        <!-- 失効処理後ポイント残高 -->
      <el-table-column
        class-name="col-2"
        :label="$t('title.system.point.table.invalidAfterBalance')">
        <span slot-scope="scope" :class="{color: sumRealPoint(scope.row) > 0}">
            {{afterUpdateSum(scope.row)}}
        </span>
      </el-table-column>

      <!--   その他操作列   -->
      <el-table-column class-name="col-2">
        <div slot-scope="scope" class="detail-button with-100">
          <sp-smart-button @click="handleEditAction(scope.row)" class="detailed-but with-100">
            {{$t("button.common.data.edit")}}
          </sp-smart-button>
        </div>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import SpSmartButton from "@/components/common/sp-smart-button"
import moment from 'moment'
const EVENT_EDIT = "on-edit"
export default {
  components:{
    SpSmartButton: SpSmartButton
  },
  name: "CompanyWalletUserPointSearchResultBeautify",
  data() {
    return {
      invalidationPointTotal: 0
    }
  },
  props: {
    result: Array,
    isShow: Boolean,
    dateMonth: Array
  },
  methods: {
    getResult(){
      return this.result
    },
    setPointList(walletId,result){
      let flag = true
      this.result.forEach(data => {
        if(data.walletId == walletId){
          data.pointList = result
        }
        data.pointList.forEach(point =>{
          if(point.invalidAmount > 0){
            flag = false
          }
        })
      })
      return flag
    },
    sumRealPoint(row){
      let sumRealPoint = 0;
        row.pointList.forEach(data =>{
          sumRealPoint = sumRealPoint + data.invalidAmount
        })
      return Number(sumRealPoint);
    },
    afterUpdateSum(row){
      let sumBalance = 0
        row.pointList.forEach(data =>{
          sumBalance = sumBalance + data.balance
        })
      return sumBalance;
    },
    //編集バータン
    handleEditAction(val) {
      this.$emit(EVENT_EDIT,val)
    },

    getMonth(val){
      if(val != null && this.dateMonth !== undefined && this.dateMonth !== null && this.dateMonth.length !== 0){
        return moment(new Date(this.dateMonth[val])).format("YYYY年M月D日") + 'まで'
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.color {
  color: #329CA6;
}
.btn-operate-other {
  margin-left: 5px;
}
.search-result-wrapper {
  height: 300px;
  overflow-y: scroll;
}
::v-deep .cell {
  height: auto;
}

.table-type {
  width: 100%;
}
.button_left {
  float: left;
  width: 80px;
  margin-right: 16px !important;
}
.button_right {
  float: left;
  width: 80px;
}


::v-deep .my-button {
  width: 103px !important;
  height: 40px !important;
}

::v-deep .small-title{
  font-size: 16px;
  margin-bottom: 36px;
  color: #525250;
}
::v-deep .el-table .cell {
  font-size: 12px;
  white-space: pre-line;
  padding-left: 0px;
}
::v-deep .el-table td{
  padding-bottom: 15px;
  padding-top: 15px;
}
::v-deep .detail-button{
 text-align: center;
}
::v-deep .el-table thead tr th {
  vertical-align: bottom  !important;
}
</style>
